import { Routes } from "@angular/router";
import { IasHomepageComponent } from "./website/pages/main-page/ias-homepage/ias-homepage.component";
import { MainPageComponent } from "./website/pages/main-page/main-page.component";
import { IasLoginComponent } from "./authmodule/ias-login/ias-login.component";
import { IasForgotpasswordComponent } from "./authmodule/ias-forgotpassword/ias-forgotpassword.component";
import { IasSignupComponent } from "./authmodule/ias-signup/ias-signup.component";
import { authGuard } from "./authmodule/auth.guard";
import { noAuthGuard } from "./authmodule/guards/no-auth.guard";
import { StateLandingPageComponent } from "./state-website/pages/state-landing-page/state-landing-page.component";

export const routes: Routes = [
  {
    path: "homepage",
    canActivate: [authGuard],
    component: MainPageComponent,
    children: [
      {
        path: "",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/main-page/ias-homepage/ias-homepage.component"
          ).then((m) => m.IasHomepageComponent),
      },
      {
        path: "about-us",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import("./website/pages/ias-aboutus/ias-aboutus.component").then(
            (m) => m.IasAboutusComponent,
          ),
      },
      {
        path: "contact-us",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import("./website/pages/ias-contactus/ias-contactus.component").then(
            (m) => m.IasContactusComponent,
          ),
      },
      {
        path: "community",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import("./website/pages/ias-community/ias-community.component").then(
            (m) => m.IasCommunityComponent,
          ),
      },
      {
        path: "my-posts",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import("./website/pages/my-posts/my-posts.component").then(
            (m) => m.MyPostsComponent,
          ),
      },
      {
        path: "post",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import("./website/pages/post/post.component").then(
            (m) => m.PostComponent,
          ),
      },
      {
        path: "caruna",
        loadComponent: () =>
          import(
            "./website/pages/resources/ias-caruna/ias-caruna.component"
          ).then((m) => m.IasCarunaComponent),
      },
      {
        path: "all-members",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/membership/all-members/all-members.component"
          ).then((m) => m.AllMembersComponent),
      },
      {
        path: "news-blogs",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/resources/news-blogs/news-blogs.component"
          ).then((m) => m.NewsBlogsComponent),
      },
      {
        path: "good-governance-initiatives",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/resources/case-studies/case-studies.component"
          ).then((m) => m.CaseStudiesComponent),
      },
      {
        path: "read-good-governance-initiatives",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/resources/readmore-case-studies/readmore-case-studies.component"
          ).then((m) => m.ReadmoreCaseStudiesComponent),
      },
      {
        path: "caruna",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/resources/ias-caruna/ias-caruna.component"
          ).then((m) => m.IasCarunaComponent),
      },
      {
        path: "welfare-membership",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/membership/welfare-membership/welfare-membership.component"
          ).then((m) => m.WelfareMembershipComponent),
      },
      {
        path: "lifetime-membership",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/membership/lifetime-membership/lifetime-membership.component"
          ).then((m) => m.LifetimeMembershipComponent),
      },
      {
        path: "readmorenews",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/resources/readmore-news/readmore-news.component"
          ).then((m) => m.ReadmoreNewsComponent),
      },
      {
        path: "readmoreblogs",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/resources/readmore-blogs/readmore-blogs.component"
          ).then((m) => m.ReadmoreBlogsComponent),
      },
      {
        path: "membership",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/membership/combined-member-page/combined-member-page.component"
          ).then((m) => m.CombinedMemberPageComponent),
      },

      {
        path: "Refund-Cancellation-Policy",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import(
            "./website/pages/refund-cancellation-policy/refund-cancellation-policy.component"
          ).then((m) => m.RefundCancellationPolicyComponent),
      },
      {
        path: "coming-soon",
        // component:IasHomepageComponent,
        loadComponent: () =>
          import("./common/coming-soon/coming-soon.component").then(
            (m) => m.ComingSoonComponent,
          ),
      },
    ],
  },
  {
    path: "microsite",
    canActivate: [authGuard],
    // loadChildren: () => import('../app/state-website/pages/state-landing-page/state-landing-page.component').then(m => m.StateLandingPageComponent),
    component: StateLandingPageComponent,
  },
  {
    path: "",
    canActivate: [noAuthGuard],
    component: IasLoginComponent,
  },
  {
    path: "auth/callback",
    canActivate: [noAuthGuard],
    component: IasLoginComponent,
  },
   {
        path: 'airpay-demo',
        loadComponent: () =>
            import('./website/pages/airpay-demo/airpay-demo.component')
                .then(m => m.AirpayDemoComponent),
    },
  {
    path: "signup",
    canActivate: [noAuthGuard],
    component: IasSignupComponent,
  },
  {
    path: "forget-password",
    canActivate: [noAuthGuard],
    component: IasForgotpasswordComponent,
  },

  {
    path: "home",
    canActivate: [authGuard],
    data: { roles: ["admin"] },
    loadComponent: () =>
      import("./IAS-portal/dashboard-layout/dashboard-layout.component").then(
        (m) => m.DashboardLayoutComponent,
      ),
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./IAS-portal/pages/dashboard/dashboard.component").then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: "profile",
        loadComponent: () =>
          import("./IAS-portal/pages/profile-info/profile-info.component").then(
            (m) => m.ProfileInfoComponent,
          ),
      },
      {
        path: "publications",
        loadComponent: () =>
          import("./IAS-portal/pages/publications/publications.component").then(
            (m) => m.PublicationsComponent,
          ),
      },
      {
        path: "blogs",
        loadComponent: () =>
          import("./IAS-portal/pages/blogs/blogs.component").then(
            (m) => m.BlogsComponent,
          ),
      },
      {
        path: "news",
        loadComponent: () =>
          import("./IAS-portal/pages/news/news.component").then(
            (m) => m.NewsComponent,
          ),
      },
      {
        path: "case-study",
        loadComponent: () =>
          import("./IAS-portal/pages/case-studies/case-studies.component").then(
            (m) => m.CaseStudiesComponent,
          ),
      },
      {
        path: "mom",
        loadComponent: () =>
          import("./IAS-portal/pages/mo-m/mo-m.component").then(
            (m) => m.MoMComponent,
          ),
      },
      {
        path: "feedbacks",
        loadComponent: () =>
          import("./IAS-portal/pages/feedbacks/feedbacks.component").then(
            (m) => m.FeedbacksComponent,
          ),
      },
      {
        path: "my-transaction",
        loadComponent: () =>
          import(
            "./IAS-portal/pages/my-transaction/my-transaction.component"
          ).then((m) => m.MyTransactionComponent),
      },
      {
        path: "approved-user",
        loadComponent: () =>
          import(
            "./IAS-portal/pages/approved-user/approved-user.component"
          ).then((m) => m.ApprovedUserComponent),
      },
      {
        path: "pending-approval-user",
        loadComponent: () =>
          import(
            "./IAS-portal/pages/not-approved-user/not-approved-user.component"
          ).then((m) => m.NotApprovedUserComponent),
      },
      {
        path: "rejected-user",
        loadComponent: () =>
          import(
            "./IAS-portal/pages/rejected-users/rejected-users.component"
          ).then((m) => m.RejectedUsersComponent),
      },
      {
        path: "user-info",
        loadComponent: () =>
          import(
            "./IAS-portal/pages/detailed-user-info/detailed-user-info.component"
          ).then((m) => m.DetailedUserInfoComponent),
      },
      {
        path: "donation",
        loadComponent: () =>
          import("./IAS-portal/pages/donations/donations.component").then(
            (m) => m.DonationsComponent,
          ),
      },
    ],
  },

  {
    path: "user-home",
    canActivate: [authGuard],
    data: { roles: ["user"], statuses: ["approved"] },
    loadComponent: () =>
      import("./user-portal/user-dashboard/user-dashboard.component").then(
        (m) => m.UserDashboardComponent,
      ),
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./user-portal/pages/user-home/user-home.component").then(
            (m) => m.UserHomeComponent,
          ),
      },
      {
        path: "user-profile",
        loadComponent: () =>
          import(
            "./user-portal/pages/user-profile/user-profile.component"
          ).then((m) => m.UserProfileComponent),
      },
      {
        path: "user-events",
        loadComponent: () =>
          import("./user-portal/pages/user-events/user-events.component").then(
            (m) => m.UserEventsComponent,
          ),
      },
      {
        path: "user-membership",
        loadComponent: () =>
          import(
            "./user-portal/pages/user-membership/user-membership.component"
          ).then((m) => m.UserMembershipComponent),
      },
      {
        path: "user-members",
        loadComponent: () =>
          import(
            "./user-portal/pages/user-members/user-members.component"
          ).then((m) => m.UserMembersComponent),
      },
      {
        path: "user-transactions",
        loadComponent: () =>
          import(
            "./user-portal/pages/my-transactions/my-transactions.component"
          ).then((m) => m.MyTransactionsComponent),
      },
      {
        path: "my-donation",
        loadComponent: () =>
          import(
            "./user-portal/pages/user-donations/user-donations.component"
          ).then((m) => m.UserDonationsComponent),
      },
      {
        path: "payment-status",
        loadComponent: () =>
          import(
            "./user-portal/pages/payment-status/payment-status.component"
          ).then((m) => m.PaymentStatusComponent),
      },
      {
        path: "feedback-consultation",
        loadComponent: () =>
          import(
            "./user-portal/pages/consultation/consultation.component"
          ).then((m) => m.ConsultationComponent),
      },
      {
        path: "view-consultation",
        loadComponent: () =>
          import(
            "./user-portal/pages/view-consultation/view-consultation.component"
          ).then((m) => m.ViewConsultationComponent),
      },
    ],
  },

  {
    path: "state-dashboard",
    canActivate: [authGuard],
    data: { roles: ["state_association_admin"], statuses: ["approved"] },
    loadComponent: () =>
      import(
        "./state-dashboard/state-dashboard-layout/state-dashboard-layout.component"
      ).then((m) => m.StateDashboardLayoutComponent),
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./state-dashboard/pages/state-about-us/state-about-us.component"
          ).then((m) => m.StateAboutUsComponent),
      },
      {
        path: "state-news",
        loadComponent: () =>
          import(
            "./state-dashboard/pages/state-news/state-news.component"
          ).then((m) => m.StateNewsComponent),
      },
      {
        path: "state-events",
        loadComponent: () =>
          import(
            "./state-dashboard/pages/state-events/state-events.component"
          ).then((m) => m.StateEventsComponent),
      },
      {
        path: "state-office-bearers",
        loadComponent: () =>
          import(
            "./state-dashboard/pages/state-office-bearers/state-office-bearers.component"
          ).then((m) => m.StateOfficeBearersComponent),
      },
      {
        path: "state-gallery",
        loadComponent: () =>
          import(
            "./state-dashboard/pages/state-gallery/state-gallery.component"
          ).then((m) => m.StateGalleryComponent),
      },
    ],
  },

  {
    path: "user-not-aproved",
    data: { statuses: ["created"] },
    loadComponent: () =>
      import(
        "./common/user-not-approved-layout/user-not-approved-layout.component"
      ).then((m) => m.UserNotApprovedLayoutComponent),
  },

  {
    path: "Terms-Conditions",
    loadComponent: () =>
      import(
        "./website/pages/terms-conditions/terms-conditions.component"
      ).then((m) => m.TermsConditionsComponent),
  },
  {
    path: "Privacy-Policy",
    loadComponent: () =>
      import("./website/pages/privacy-policy/privacy-policy.component").then(
        (m) => m.PrivacyPolicyComponent,
      ),
  },

  {
    path: "login",
    redirectTo: "",
    pathMatch: "full",
  },

  {
    path: "login/",
    redirectTo: "",
    pathMatch: "full",
  },

  {
    path: "**", // wildcard → catch all unknown routes
    loadComponent: () =>
      import("./common/route-error/route-error.component").then(
        (m) => m.RouteErrorComponent,
      ),
  },
];
